<div class="crm-parent d-flex flex-column flex-grow-1">
  <div class="outlet crm-container d-flex flex-column flex-grow-1">
    <div class="d-flex flex-column flex-grow-1">
      <rms-struct-cap-crm-table class="d-flex flex-column"></rms-struct-cap-crm-table>
    </div>
  </div>
</div>
